//imgs
import img01 from "../../assets/images/chapters/07/01.jpg";
import img02 from "../../assets/images/chapters/07/02.jpg";
import img03 from "../../assets/images/chapters/07/03.jpg";
import img04 from "../../assets/images/chapters/07/04.jpg";

import { captions, list } from "../../assets/data/chapters/chapter07";

//scroll reveal
import ScrollReveal from "../scrollReveal";

const Chapter = () => {
  return (
    <div id="chapter07">
      <div className="group01">
        <ScrollReveal className="title">
          <span>landing</span>
          <span>↘↘↘</span>
        </ScrollReveal>
        <div className="row">
          <ScrollReveal className="column">
            <img src={img01} />
            <img src={img02} />
            <p className="caption">{captions[0]}</p>
          </ScrollReveal>
          <ScrollReveal className="column">
            <div className="picture">
              <img src={img03} />
            </div>
            <p className="caption">{captions[1]}</p>
          </ScrollReveal>
        </div>
      </div>

      <div className="group02">
        {list.map((elem, i) => (
          <ScrollReveal key={i} className="picture">
            <img src={elem} />
          </ScrollReveal>
        ))}
      </div>

      <div className="group03">
        <ScrollReveal className="title">
          <span>THRUSTERS</span>
        </ScrollReveal>
        <ScrollReveal className="picture">
          <img src={img04} />
          <p className="caption">{captions[2]}</p>
        </ScrollReveal>
      </div>
    </div>
  );
};

export default Chapter;
